import { ConsentFormDataMock, ConsentFormResMock } from '../types/consent_form.type'
import { GeneralResMock } from '../types/general.type'
import { MedicationDataMock, MedicationIncluded } from '../types/medication.type'
import { LabResultResponse } from '../types/result.type'
import AXIOS_INSTANCE from './axiosInstance'

type MedicationsRes = GeneralResMock<MedicationDataMock[], MedicationIncluded[]>
type Params = Record<string, string | number>

// Medicines that were actually given (the medicines and inpatient chart blocks).
const ADMINISTERED_STATUSES = ['onhold', 'ongoing', 'completed', 'discontinued']
// Discharge medicines still to be taken: everything except stopped or rejected orders. Pending stays —
// discharge medicines are take-home prescriptions that never go through pharmacy verification (only
// admitted orders do), so pending is their normal status.
export const DISCHARGE_MEDICATION_STATUSES = [
  'pending',
  'review_requested',
  'verified',
  'ongoing',
  'completed',
  'onhold'
]
const statusQuery = (statuses: string[]) => statuses.map(status => `status[]=${status}`).join('&')

const fetchMedications = async (query: string, params?: Params) => {
  const { data } = await AXIOS_INSTANCE.get<MedicationsRes>(`medications?${query}`, params ? { params } : undefined)
  return data
}

export const dSummaryNote = {
  fetchDischargeMedication: (encounterId: string, params?: Params) =>
    fetchMedications(
      `encounter_id=${encounterId}&context=post_discharge&${statusQuery(DISCHARGE_MEDICATION_STATUSES)}`,
      params
    ),
  // The inpatient block: only the medicines of the admission (context admitted), never discharge medicines.
  fetchInpatientMedication: (encounterId: string, params?: Params) =>
    fetchMedications(`${statusQuery(ADMINISTERED_STATUSES)}&encounter_id=${encounterId}&context=admitted`, params),
  fetchLabResult: async (encounterId: string) => {
    const { data } = await AXIOS_INSTANCE.get<LabResultResponse>(`lab_results?encounter_id=${encounterId}`)
    return data
  },
  fetchMedication: (encounterId: string, params?: Params) =>
    fetchMedications(`${statusQuery(ADMINISTERED_STATUSES)}&encounter_id=${encounterId}`, params),
  fetchProcedure: async (encounterId: string, patientId: string) => {
    const { data } = await AXIOS_INSTANCE.get<ConsentFormResMock<ConsentFormDataMock[]>>(
      `consent_forms?encounter_id=${encounterId}&patient_id=${patientId}`
    )
    return data
  }
}
